import { createContext, useContext } from 'react'

/**
 * Base path the shared console panels read from (Enterprise teams,
 * 2026-10-03). The DealCloser Staff Console uses /api/admin (every customer);
 * the client team console reuses the SAME panels with /api/team, which the
 * leads worker scopes to the manager's own org. Panels also use it to hide
 * staff-only actions (comp, impersonation, promo codes) in the team view.
 */
export type AdminApiBase = '/api/admin' | '/api/team'

export const AdminApiBaseContext = createContext<AdminApiBase>('/api/admin')

export function useAdminApiBase(): AdminApiBase {
  return useContext(AdminApiBaseContext)
}

/** React Query key scope so staff and team caches never mix. */
export function scopeOf(base: AdminApiBase): 'admin' | 'team' {
  return base === '/api/team' ? 'team' : 'admin'
}
